export interface IFilterChangedNotificationProps {
    filterChangeEducationalTooltipPresented: boolean;
    onFilterChangedEducationalTooltipPresented: VoidFunction;
    tooltipBody: string;
    filterType: EFilterChangedTooltipTypes;
    button?: any;
    onClose?: VoidFunction;
    onClick?: (event: FixmeType) => void;
    placement?: string;
    width?: number;
}

export enum EFilterChangedTooltipTypes {
    DATE_PICKER,
    COUNTRY_PICKER,
    WEB_SOURCE_PICKER,
}
